<template>
  <v-progress-circular
    :value="this.value"
    :size="180"
    :width="22"
    color="primary"
    rotate="-90"
  >
    <div class="d-flex flex-column">
      <h1 class="display-2 text-black" v-if="value != null">{{ value }}%</h1>
      <div>
        <v-chip v-if="secondaryValue > 0" small color="colorAlertGreenLt">
          <v-icon left small color="colorAlertGreen">mdi-arrow-up</v-icon>
          <div>{{ secondaryValue }}%</div>
        </v-chip>
        <v-chip v-if="secondaryValue < 0" small color="colorAlertRedLt">
          <v-icon left small color="colorAlertRed">mdi-arrow-down</v-icon>
          <div>{{ secondaryValue }}%</div>
        </v-chip>
      </div>
    </div>
  </v-progress-circular>
</template>

<script>
export default {
  name: "ProgressCircle",
  props: {
    value: {
      type: Number,
      default: null
    },
    secondaryValue: {
      type: Number,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped></style>
